import { render } from "./FormSubsidyEnergyLabelView.vue?vue&type=template&id=46f9232a"
import script from "./FormSubsidyEnergyLabelView.vue?vue&type=script&lang=js"
export * from "./FormSubsidyEnergyLabelView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__